/**
 * Export Jurisdiction and Classification U.S. EAR99, India Not Subject to Regulations
 */

import React, { useEffect, useState, type ReactNode } from "react";

interface ZoomWrapperProps {
  children: ReactNode;
}

/**
 * ZoomWrapper scales the entire page for smaller screens using CSS zoom.
 * Works best for internal apps in Chrome/Edge.
 */
const AppWrapper: React.FC<ZoomWrapperProps> = ({ children }) => {
  const [zoom, setZoom] = useState<number>(1);

  useEffect(() => {
    const handleResize = () => {
     const height = window.screen.availHeight;
      const myDiv = document.getElementById('root');
   
     
      const baseHeight = 900; // Example: a height where you want 100% zoom

      if (height < baseHeight) {
        setZoom(height / baseHeight); // Calculate zoom level based on height ratio
      } else {
        setZoom(1);
      }
    };
    window.addEventListener("resize", handleResize);
    handleResize(); // apply immediately

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const wrapperStyle: React.CSSProperties = {
    zoom: zoom,
    width: "100%",
  };

  return <div style={wrapperStyle}>{children}</div>;
};

export default AppWrapper;
